export enum AccountTransactionType{
    Receivable,
    Debt,
    null = null
}
